module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_8019.a2be8511.png";